import { XMarkIcon } from '../../Icons';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { idBuilder } from '../../internal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const defaultTitleStyle = theme => ({
  fontSize: theme.tokens.ComponentDrawerTitleDefaultFontSize,
  fontWeight: theme.tokens.ComponentDrawerTitleDefaultFontWeight,
  lineHeight: theme.tokens.ComponentDrawerTitleDefaultLineHeight,
  fontFamily: theme.tokens.ComponentDrawerTitleDefaultFontFamily,
  color: theme.tokens.ComponentDrawerTitleColor
});
const resolveTitle = function (theme, children, id, dataTestId) {
  let customIdentifiers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return /*#__PURE__*/_jsx(Box, {
    className: 'ids-slideout-title',
    sx: defaultTitleStyle(theme),
    "data-testid": customIdentifiers['title']?.dataTestId || idBuilder('ids-slideout-title', dataTestId),
    id: customIdentifiers['title']?.id || idBuilder('ids-slideout-title', id),
    children: children
  });
};
const styledDialogTitle = (theme, hasOverflow) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '20px 16px 16px 24px',
  gap: '24px'
});
export const SlideOutTitle = _ref => {
  let {
    children,
    onClose,
    id,
    displayCloseButton,
    hasOverflow,
    customIdentifiers = {},
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const effectiveTitle = resolveTitle(theme, children, id, rest['data-testid'], customIdentifiers);
  return /*#__PURE__*/_jsxs(Box, {
    sx: styledDialogTitle(theme, hasOverflow),
    className: 'ids-slideout-title-container',
    "data-testid": customIdentifiers['titleContainer']?.dataTestId || idBuilder('ids-slideout-title-container', rest['data-testid']),
    id: idBuilder(customIdentifiers['titleContainer']?.id || 'ids-slideout-title-container', id),
    children: [effectiveTitle, displayCloseButton ? /*#__PURE__*/_jsx(Box, {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: '32px',
      minHeight: '32px',
      onClick: onClose,
      className: 'ids-slideout-close-button',
      id: customIdentifiers['closeButton']?.id || idBuilder('ids-slideout-close-button', id),
      "data-testid": customIdentifiers['closeButton']?.dataTestId || idBuilder('ids-slideout-close-button', rest['data-testid']),
      children: /*#__PURE__*/_jsx(XMarkIcon, {
        fontSize: '20px',
        color: theme.tokens.SemColorOnSurfaceSubdued
      })
    }) : null]
  });
};